<template>
  <div class="peopleAuthorize_wrap">
    <div class="peopleAuthorize_left">
      <ioc-table
        ref="refPeoPleTable"
        :data="peopleTableData"
        :option="constData.peopleTable"
        :page="constData.peoplePage"
        @row-click="handleRowClick"
        @search-change="
          (val) => {
            handleSearchChange(val, 'people');
          }
        "
        @search-reset="
          (val) => {
            handleSearchReset('people');
          }
        "
        @size-change="
          (val) => {
            handleSizeChange(val, 'people');
          }
        "
        @current-change="
          (val) => {
            handleCurrentChange(val, 'people');
          }
        "
      >
      </ioc-table>
    </div>
    <div class="peopleAuthorize_right">
      <div class="searchForm">
        <el-form :model="constData.groupSearchForm" :inline="true">
          <el-form-item label="权限组名称">
            <el-input
              v-model="constData.groupSearchForm.thirdRightGroupName"
              clearable
              placeholder="请输入权限组名称"
            >
            </el-input>
          </el-form-item>
        </el-form>
        <div style="display: flex">
          <el-button
            class="query-btn"
            type="primary"
            @click="handleSearchChange(constData.groupSearchForm, 'group')"
            >查询</el-button
          >
          <el-button type="info" @click="handleSearchReset('group')"
            >重置</el-button
          >
        </div>
      </div>
      <ioc-table
        style="height: calc(100% - 50px)"
        ref="refGroupTable"
        :data="groupTableData"
        :option="constData.groupTable"
        :page="constData.groupPage"
        @selection-change="handleSelectionChange"
        @size-change="
          (val) => {
            handleSizeChange(val, 'group');
          }
        "
        @current-change="
          (val) => {
            handleCurrentChange(val, 'group');
          }
        "
        @search-change="
          (val) => {
            handleSearchChange(val, 'group');
          }
        "
        @search-reset="
          (val) => {
            handleSearchReset('group');
          }
        "
      >
        <template slot="menuLeft">
          <div>
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="small"
              @click="handleAddGroups"
            >
              添加权限组
            </el-button>
            <el-button
              type="info"
              icon="el-icon-delete"
              size="small"
              @click="handleDelGroup()"
              :disabled="!checkDelPeople.length ? true : false"
            >
              批量移除
            </el-button>
          </div>
        </template>
        <template slot="menu" slot-scope="scope">
          <el-tooltip
            class="item m5"
            effect="dark"
            content="移除"
            placement="top-start"
          >
            <el-button
              type="text"
              class="el-icon-delete"
              @click="handleDelGroup(scope.row)"
            ></el-button>
          </el-tooltip>
        </template>
      </ioc-table>
    </div>
    <groupsVue
      :personnelCode="checkPeople.personnelCode"
      :showGroupsPanel="showGroupsPanel"
      @handleCloseGroupsPanel="handleCloseGroupsPanel"
    />
  </div>
</template>
  
  <script>
import { api } from "../api/index";
import utils from "@src/common/utils";
import { groupTable } from "../config/groupTable";
import { peopleTable } from "../config/peopleTable";
import groupsVue from "../components/group.vue";
export default {
  components: {
    groupsVue,
  },
  data() {
    return {
      constData: {
        groupPage: {
          pageNum: 1,
          total: 0,
          pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
        },
        peoplePage: {
          pageNum: 1,
          total: 0,
          pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
        },
        peopleTable: peopleTable(true),
        groupTable: groupTable(true),
        groupSearchForm: {},
        peopleSearchForm: {},
      },
      subLoading: false,
      tableLoading: false,
      showGroupsPanel: false,
      groupTableData: [],
      peopleTableData: [],
      checkPeople: {
        personnelCode: "",
      },
      checkDelPeople: [],
    };
  },
  created() {},
  mounted() {
    this.peopleGetList();
  },
  methods: {
    // 点击人员获取所属权限组
    handleRowClick(row) {
      this.checkPeople = { ...row };
      this.groupGetList();
    },
    // 条件搜索
    handleSearchChange(param, type) {
      this.constData[`${type}Page`].pageNum = 1;
      this.constData[`${type}SearchForm`] = Object.assign({}, param);
      this[`${type}GetList`]();
    },
    // 条件重置
    handleSearchReset(type) {
      this.constData[`${type}Page`].pageNum = 1;
      this.constData[`${type}Page`].pageSize = 10;
      this.constData[`${type}SearchForm`] = {};
      this[`${type}GetList`]();
    },
    // 分页查询
    handleCurrentChange(val, type) {
      this.constData[`${type}Page`].pageNum = val;
      this[`${type}GetList`]();
    },
    // 条数查询
    handleSizeChange(val, type) {
      this.constData[`${type}Page`].pageNum = 1;
      this.constData[`${type}Page`].pageSize = val;
      this[`${type}GetList`]();
    },
    // 多选
    handleSelectionChange(row) {
      this.checkDelPeople = [...row];
    },
    // 添加权限组
    handleAddGroups() {
      this.showGroupsPanel = true;
    },
    handleDelGroup(row) {
      this.$confirm("您确定将人员从所属权限组移除吗?", "移除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {};
        if (!row) {
          // 批量移除
          params.authCodeList = this.checkDelPeople.map((el) => {
            return el.authCode;
          });
        } else {
          params.authCodeList = [row.authCode];
        }
        this.$fetch(api.person.deleteAuthority, params).then((response) => {
          if (response && response.success) {
            this.$message({
              message: "移除成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
          }
          this.groupGetList();
        });
      });
    },
    handleCloseGroupsPanel(type) {
      if (type == true) {
        this.groupGetList();
      }
      this.showGroupsPanel = false;
    },
    //根据人员查询权限组
    groupGetList() {
      let params = {
        ...this.constData.groupPage,
        ...this.constData.groupSearchForm,
        personnelCodeList: [this.checkPeople.personnelCode],
        personnelType: 1,
      };
      this.$fetch(api.getAuthorityList, params).then((res) => {
        if (!res.success) {
          this.$$message.error(res.msgContent || "获取数据失败");
          return;
        }
        this.groupTableData = res.returnObj.list.map((el) => {
          return el;
        });
        this.constData.groupPage.total = res.returnObj.total;
      });
    },
    // 获取所有人员
    peopleGetList() {
      let params = {
        ...this.constData.peoplePage,
        ...this.constData.peopleSearchForm,
      };
      this.$fetch(api.getPeople, params).then((res) => {
        if (!res.success) {
          this.$$message.error(res.msgContent || "获取数据失败");
          return;
        }
        this.peopleTableData = res.returnObj.list.map((el) => {
          return el;
        });
        this.constData.peoplePage.total = res.returnObj.total;
        let row = { ...this.peopleTableData[0] };
        this.$refs.refPeoPleTable.$refs.multipleTable.setCurrentRow(row);
        this.handleRowClick(row);
      });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.peopleAuthorize {
  &_wrap {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
  }
  &_right {
    width: 600px;
    height: 100%;
  }
  &_left {
    width: calc(100% - 616px);
    height: 100%;
  }
}
</style>